/*= ========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
========================================================================================== */
const colors = {
  primary: '#00B074', // Archistar Green
  secondary: '#61C2F0',
  tertiary: '#123241',
  action: '#FCB651',
  success: '#28C76F',
  danger: '#F05A5B', // Error
  warning: '#FF9F43',
  dark: '#123241', // Dark Active Text
  purple: '#8D7FF8',
  pink: '#FF98D9',
  red: '#F05A5B',
  orange: '#F38354',
  yellow: '#ECAF2D',
  green: '#32CD98', // Light Green
  darkBlue: '#123241',
  lighterBlue: '#1F4A5C',
  inactiveButton: '#E3E5E4',
  activeButton: '#1F4A5C',
  inactiveText: '#879CA5',
  divider: '#E6E6E6',
  lightGrey: '#F8F8F8',
  academyPrimary: '#39827D'
};
const lotTypeColor = {
  townhouse: '#61C2F0',
  house: '#F05A5B',
  hotel: '#FF98D9',
  manor: '#123241',
  apartment: '#F38354',
  subdivision: '#ECAF2D',
  mixeduse: '#32CD98',
  commercial: '#8D7FF8',
  duplex: '#1F4A5C',
  terrace: '#00B074'
};
// CONFIGS
const themeConfig = {
  footerType: 'static', // options[String]  : static(default) / sticky / hidden
  hideScrollToTop: false, // options[Boolean] : true, false(default)
  mainLayoutType: 'horizontal', // options[String]  : vertical(default) / horizontal
  navbarColor: '#fff', // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: 'sticky', // options[String]  : floating(default) / static / sticky / hidden
  routerTransition: 'fade', // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  sidebarCollapsed: false, // options[Boolean] : true, false(default)
  theme: 'light', // options[String]  : "light"(default), "dark", "semi-dark"
  colors,
  lotTypeColor,
  // Not required yet - WIP
  userInfoLocalStorageKey: 'userInfo'

  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
};

export default themeConfig;
